import { useNavigate } from 'react-router';
import { editCifApi, editCifApiNorm } from "@/api/placeOffer";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { ShimmerContentBlock } from "react-shimmer-effects";
import Header from "@/components/common/header/DefaultHeader";
import MobileMenu from "@/components/common/header/MobileMenu";
import PopupSignInUp from "@/components/common/PopupSignInUp";
import EditCifBody from "./EditCifBody";
import "./index.css";
import CifFalloutPage from "./CifFalloutPage";
import NotFoundPage from "@/pages/not-found";
import { useDispatch, useSelector } from "react-redux";
import {
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
  setShowSessionMsg,
} from "@/redux/login/loginSlice";
import { getCookie } from "@/utils/cookies";
import ErrorPageContent from "../404/ErrorPageContent";
import { getUserProfile } from "@/api/myProfile";
import OtherLinkFooter from '../common/footer/OtherLinkFooter';
import NewFooter from '../common/footer/NewFooter';

const EditCifOffer = () => {
  const [state, setState] = useState({});
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const profileInfo = useSelector((state) => state.user.user);
 const [formState,setFormState] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchUserProfile = async () => {
      try {
        const { status, data } = await getUserProfile();
        // console.log("loppppp", data);
        if (status === "SESSION_REQUIRED") {
          navigate("/");
          return;
        }
        setFormState(data);
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

  const getEditOfferData = async () => {
    try {
      setLoading(true);
      const data = await editCifApi({ id });
      const data1 = await editCifApiNorm({ id });
     // await getExperiments("onLoad");
      if (data1?.data) {
        setDocuments(data1?.data);
      } else {
        setDocuments(data1);
      }

      setState(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (profileInfo?.userEmailId || getCookie("userEmail")) {
      fetchUserProfile()
      getEditOfferData();
      dispatch(setLoginModal(false));
    } else {
      dispatch(setLoginModal(true));
      dispatch(setLoginTab("loginTab"));
      dispatch(setLoginCallLocation("Popup"));
      dispatch(setShowSessionMsg(false));
    }
  }, [profileInfo?.userEmailId]);

  return (
    <>
      {loading ? (
        <>
          <div className="offer-loader p-5 mb-5">
            <ShimmerContentBlock
              title
              text
              cta
              thumbnailWidth={370}
              thumbnailHeight={370}
            />
          </div>
        </>
      ) : (
        <>
          <Header />
          <MobileMenu />
          <PopupSignInUp />
          {typeof state === "string" && state.startsWith(")]}'") ? (
            <>
                <section className="our-error">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <ErrorPageContent />
            </div>
          </div>
        </div>
        
      </section>
            </>
          ) : (
            <div className="container offer " style={{ margin: "7rem auto" }}>
              <div className="offer-body-main">
                {state?.step === "CI_COMPLETED" ||
                state?.step === "CI_FALLOUT" ? (
                  <CifFalloutPage data={state} />
                ) : (
                  <>
                    {!profileInfo?.userEmailId ? (
                      <></>
                    ) : (
                      <>
                        <EditCifBody
                          state={state}
                          cifId={id}
                          documents={documents}
                          formState={formState}
                        />
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
          {/* <section className="bg-ptrn2 footer_one home6">
            <div className="container">
              <div className="row">
                <Footer />
              </div>
            </div>
          </section>
          <section className="footer_middle_area home6 pb30 pt30">
            <div className="container"></div>
          </section> */}
           <div className="container-fluid px-0">
                      {/* <Footer /> */}
                      <OtherLinkFooter/>
                      <NewFooter/>
                  </div>
        </>
      )}
    </>
  );
};

export default EditCifOffer;
